var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CustomTooltip } from '@project/components/base';
import { AppBuilderMenuIcon, AppBuilderMenuContainer, AppBuilderMenuItemText, } from './styles';
export var AppBuilderMenuItem = function (_a) {
    var title = _a.title, iconName = _a.iconName, tooltipText = _a.tooltipText;
    return (_jsxs(AppBuilderMenuContainer, { children: [_jsx(AppBuilderMenuIcon, { icon: iconName }), tooltipText ? (_jsx(CustomTooltip, __assign({ title: tooltipText }, { children: _jsx(AppBuilderMenuItemText, { children: title }) }))) : (_jsx(AppBuilderMenuItemText, { children: title }))] }));
};
export default AppBuilderMenuItem;
